/**
 * Tab navigation for entity pages (Table / Data Sources)
 */

import { Table2, Database } from 'lucide-react'
import { cn } from '../../lib/utils'

export type EntityPageTab = 'table' | 'data-sources'

interface EntityPageTabsProps {
  activeTab: EntityPageTab
  onTabChange: (tab: EntityPageTab) => void
  /** Custom label for the first tab (default: "Tabelle") */
  tableTabLabel?: string
}

interface TabConfig {
  id: EntityPageTab
  label: string
  icon: React.ReactNode
}

export function EntityPageTabs({ activeTab, onTabChange, tableTabLabel = 'Tabelle' }: EntityPageTabsProps) {
  const TABS: TabConfig[] = [
    { id: 'table', label: tableTabLabel, icon: <Table2 className="w-4 h-4" /> },
    { id: 'data-sources', label: 'Datenquellen', icon: <Database className="w-4 h-4" /> },
  ]
  return (
    <div className="flex gap-1 p-1 bg-gray-100 rounded-lg w-fit">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={cn(
            'flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-colors',
            activeTab === tab.id
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
          )}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  )
}
